export enum InfoBarTypes {
  Warning = 'warning',
  Info = 'info',
  Danger = 'danger',
  Notification = 'notification',
  Success = 'success'
}
export enum InfoBarIconNames {
  Warning = 'warningIcon',
  Danger = 'dangerIcon',
  Info = 'infoIcon',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Notification = 'infoIcon',
  Success = 'successGreenIcon'
}

export interface ImageDimensions {
  width: number
  height: number
}

export type VueformElementRef<T> = { value: T; update: (v: T) => void } | null
export type VueformInputRef = { input: HTMLInputElement | null } | null
